module.exports = __webpack_public_path__ + "static/illustration-6756ce49a962f695ac26996c91c15c63.svg";